import * as React from "react";

import tinycolor2 from "tinycolor2";

export interface IInlineStyle {
	portletInstanceId: number;
	backgroundColor: string;
	selectedDateColor: string;
	todayColor: string;
}

function darkenColor(color: string, percentDarker: number): string {
	const tcOriginalColor = tinycolor2(color);
	return tcOriginalColor.darken(percentDarker).toHexString();
}

export const InlineStyle = (props: IInlineStyle) => {

	const id = "portlet" + props.portletInstanceId;

	const bgColor = (props.backgroundColor) ? props.backgroundColor : "#256497";

	const selectedDateColor = (props.selectedDateColor) ? props.selectedDateColor : "#fff3c1";
	const selectedDateColorBorder = darkenColor(selectedDateColor, 10);

	const hoverColor = darkenColor(selectedDateColor, -10);
	const hoverColorBorder = darkenColor(selectedDateColor, -5);

	const todayColor = (props.todayColor) ? props.todayColor : "#d4fbdc";
	const todayColorBorder = darkenColor(todayColor, 10);

	return (
		<style dangerouslySetInnerHTML={{
			__html: `

	/*-- Box BACKGROUND COLOR --*/
	#${id}.PO-calendar .CAL-box {
		background: ${bgColor} !important;
	}

	/*-- MONTH SELECTOR, EVENTS COLOR --*/
	#${id}.PO-calendar .CAL-box .CAL-topControls .CAL-DD-monthGrid li.CAL-DD-monthButton a:hover, 
	#${id}.PO-calendar .CAL-box .CAL-topControls .CAL-DD-monthGrid li.CAL-DD-monthButton a:focus, 
	#${id}.PO-calendar .CAL-box .CAL-topControls .CAL-DD-monthGrid li.CAL-DD-monthButton a.CAL-active, 
	#${id} .CAL-EV-Item a {
		background: ${bgColor};
		color: #ffffff !important;
	}

	/*-- BIG MONTH, DAYS OF THE WEEK COLOR --*/
	#${id}.PO-calendar .CAL-box .CAL-topControls .CAL-monthSelector, 
	#${id}.PO-calendar .CAL-box .CAL-daysOfWeek ul li {
		color: #ffffff !important;
	}

	/*-- Selected Day (Selected Colors) --*/
	#${id} .CAL-V-MV-selectDay:hover, 
	#${id} .CAL-V-MV-selectDay:focus, 
	#${id} .CAL-V-MV-selectDay.CAL-V-MV-SD-selected	 {
		background: ${hoverColor} ;
		border-color: ${hoverColorBorder} ;
	}

	/*-- Selected Day (Selected Colors) --*/
	#${id} .CAL-V-MV-selectDay.CAL-V-MV-SD-selected	 {
		background: ${selectedDateColor} ;
		border-color: ${selectedDateColorBorder} ;
	}

	/*-- Today and Selected Hover (Selected Colors) --*/
	#${id} .CAL-V-today .CAL-V-MV-selectDay:hover {
		background: ${hoverColor} ;
		border-color: ${hoverColorBorder} ;
	}

	/*-- Hover Cell (Today Colors) --*/
	#${id} .CAL-V-today .CAL-V-MV-selectDay {
		background: ${todayColor} ;
		border: 1px solid ${todayColorBorder} ;
	}

	/*-- Additional Event Plus Button --*/
	#${id} .CAL-EV-Item.CAL-EV-plus a {
		background: #eeeeee !important;
		color: #333333 !important;
	} 

	`}} />
	);
};
